var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "invite-btn__outer" },
    [
      _vm.isPicView && _vm.showInviteBtn
        ? _c(
            "DialogSlot",
            {
              ref: "inviteModal",
              attrs: {
                id: "project-detail-invite-vendor",
                modalBtn: _vm.$t("action.invite"),
                modalHeader: _vm.modalTitle,
                beforeOpenModal: _vm.checkRequiredInfoBeforeInvite,
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "slot-content font-bold invite-btn__content",
                  attrs: { slot: "content" },
                  slot: "content",
                },
                [
                  _c("div", { staticClass: "vendor-name" }, [
                    _vm._v("\n        " + _vm._s(_vm.vendorName) + "\n      "),
                  ]),
                  _vm._v(" "),
                  !_vm.isValidateTenderDlp
                    ? _c("div", { staticClass: "without-dlp" }, [
                        _vm._v(
                          "\n        " +
                            _vm._s(
                              _vm.$t(
                                "project.inviteVendorWithoutDlpDate.content"
                              )
                            ) +
                            "\n      "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.shouldShowUploadArea,
                          expression: "shouldShowUploadArea",
                        },
                      ],
                      staticStyle: { "padding-top": "10px" },
                    },
                    [
                      _c("label", [_vm._v(_vm._s(_vm.attachmentLabel))]),
                      _vm._v(" "),
                      _c("AttachDocs", {
                        attrs: {
                          resourceId: _vm.getAttachmentId(),
                          btnName: _vm.attachBtnLabel,
                        },
                        on: {
                          "update:attachments": function (val) {
                            return (_vm.poAttachments = val)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { attrs: { slot: "buttons" }, slot: "buttons" },
                [
                  !_vm.isValidateTenderDlp
                    ? _c("HKLButton", {
                        attrs: { color: "darkblue", action: "goback" },
                        on: { click: _vm.cancel },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("HKLButton", {
                    attrs: {
                      color: "orange",
                      action: _vm.inviteBtnAction,
                      disabled: _vm.shouldDisabledInviteBtn,
                    },
                    on: { click: _vm.notifyInvitation },
                  }),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "DialogSlot",
        {
          ref: "msg-modal",
          attrs: { id: "project-detail-invite-success", showCloseBtn: false },
        },
        [
          _c(
            "div",
            {
              staticClass: "slot-content",
              attrs: { slot: "content" },
              slot: "content",
            },
            [
              _c("div", { staticClass: "info font-bold" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$t("project.invitedMsg", [
                        _vm.projectName,
                        _vm.vendorName,
                      ])
                    ) +
                    "\n      "
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c("div", { attrs: { slot: "buttons" }, slot: "buttons" }, [
            _c(
              "button",
              {
                staticClass: "btn btn--orange close-reveal-modal",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.navToDashboard()
                  },
                },
              },
              [_vm._v("\n        " + _vm._s(_vm.$t("action.ok")) + "\n      ")]
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }